<template>
  <label
    class="bbe-address-form"
    :class="{'bbe-address-form_close': !addressesOpen}"
    :style="{
      height: `${addressesOpen ? addressesBodyHeight + 8 : 37}px`,
    }"
  >
    <div class="bbe-address-form__placeholder">{{ placeholder }}</div>
    <div
      class="bbe-address-form-content__wrapper"
      ref="bbeAddressesWrapper"
    >
      <label
        class="bbe-address-form-content"
        ref="bbeAddressesBody"
      >
        <div class="bbe-address-form-content-address"
               v-for="(address, index) in addressees"
               :key="'email_' + address">
          <span class="bbe-address-form-content-address__title">
                {{ address }}
          </span>
          <i class="email-icon-close bbe-address-form-content-address__remove"
             @click="removeAddress(index)"/>
        </div>
        <fieldset>
          <input
            class="bbe-address-form__input bbe-input"
            ref="bbeNewAddressesInput"
            :size="(inputValue.length * 1.3) + 2"
            v-model="inputValue"
            @keyup="inputKeyup"
            @blur="setBlocksDestination"
            @input="generateMessage"
            type="text"
          >
          <transition name="bbe-bounce">
            <span class="bbe-label__error bbe-address-form__error" v-if="error">{{ error }}</span>
          </transition>
          <ContactsList :style="contactListStyles"
                        :model="inputValue"
                        :addressees="addressees"
                        modelName="inputValue"
                        @setContact="setContact"/>
        </fieldset>
      </label>
    </div>
    <div class="bbe-address-form-controls">
      <div
        v-if="displayAccordionAddresses"
        class="bbe-address-form-toggle"
        :class="{'bbe-address-form-toggle_active': addressesOpen}"
        @click="toggleAccordionAddresses"
      >
        +{{ addressees.length }}
        <i class="email-icon-arrow bbe-address-form-toggle__icon"/>
      </div>
      <div class="bbe-address-form-buttons" v-if="copyButtons">
        <button class="bbe-address-form-buttons__copy"
                @click="$emit('addCopy', 'openCopy')"
                v-if="!openCopy">
          Cc
        </button>
        <button class="bbe-address-form-buttons__copy"
                @click="$emit('addCopy', 'openCopyHidden')"
                v-if="!openCopyHidden">
          Bcc
        </button>
      </div>
    </div>
  </label>
</template>

<script>
import ContactsList from '@/components/Main/FormsElements/ContactsList'
import {get, words, take} from 'lodash'
import timeout from '@/mixin/timeout'

export default {
  name: 'NewMailAddressInput',
  components: {ContactsList},
  mixins: [timeout],
  props: [
    'placeholder',
    'error',
    'openCopy',
    'openCopyHidden',
    'copyButtons',
    'model',
    'values',
    'isShowBcc'
  ],
  data () {
    return {
      addressesOpen: true,
      inputValue: '',
      lastInputValue: '',
      contactListStyles: {},
      inputRef: null,
      addressesBodyHeight: 30,
      addressees: [],
      isFirstHeight: false
    }
  },
  computed: {
    activeUser () {
      return this.$store.getters.userInfo || this.$store.getters.activeUser
    },
    noAccessMassMailing () {
      const accessUserMailing = get(this.activeUser, 'massMailingCheck', false)
      const isFounder = get(this.activeUser, 'role', '') === 'founder'
      return isFounder ? false : !accessUserMailing && this.addressees.length >= 5
    },
    displayAccordionAddresses () {
      return this.addressesBodyHeight > 60
    }
  },
  methods: {
    generateMessage () {
      this.$emit('generateMessage', {})
    },
    inputKeyup (e) {
      if (e.keyCode === 32 || e.keyCode === 188) this.setBlocksDestination()
      if (e.keyCode === 8 && !this.lastInputValue) this.removeAddress()
      this.lastInputValue = e.target.value
      this.$nextTick(() => {
        this.addressesBodyHeight = get(this.$refs, 'bbeAddressesBody.offsetHeight', 0)
      })
    },
    setBlocksDestination () {
      const addresses = words(this.inputValue, /[^, ]+/g)
      this.addressees.push(...addresses)
      this.inputValue = ''
      this.$emit('setModel', {state: this.model, addressees: this.addressees})
      this.$nextTick(() => {
        this.addressesBodyHeight = get(this.$refs, 'bbeAddressesBody.offsetHeight', 0)
      })
      this.isFirstHeight = true
    },
    removeAddress (index) {
      if (!this.addressees.length) return
      const start = index === undefined ? this.addressees.length - 1 : index
      this.addressees.splice(start, 1)
      this.setBlocksDestination()
    },
    setContact (contact, isClick) {
      if (isClick) this.addressees.splice(-1, 1)
      if (!contact) return
      this.inputValue = contact
      this.setBlocksDestination()
    },
    getInputRef () {
      this.inputRef = this.$refs.bbeNewAddressesInput
    },
    calcContactListPosition () {
      if (!this.inputRef) {
        this.getInputRef()
        return
      }
      const position = this.inputRef.getBoundingClientRect()
      this.contactListStyles = {
        position: 'fixed',
        left: position.left + 'px',
        top: position.top + position.height + 'px',
        width: position.width + 'px'
      }
    },
    toggleAccordionAddresses () {
      this.addressesOpen = !this.addressesOpen
      if (!this.addressesOpen) {
        setTimeout(() => {
          this.$emit('scrollUp')
        }, 300)
      }
      this.setBodyAddressesHeight()
    },
    setBodyAddressesHeight () {
      const wrapper = get(this.$refs, 'bbeAddressesWrapper', {})
      if (!wrapper.style) return
      if (this.isFirstHeight) {
        wrapper.style.bottom = this.addressesOpen ? 0 : `${this.addressesBodyHeight - 30}px`
        wrapper.style.maxHeight = this.addressesOpen ? '100%' : `${30}px`
      } else {
        setTimeout(() => {
          const wrapper = get(this.$refs, 'bbeAddressesWrapper', {})
          const { height } = wrapper.getBoundingClientRect()
          wrapper.style.bottom = this.addressesOpen ? 0 : `${height - 30}px`
          wrapper.style.maxHeight = this.addressesOpen ? '100%' : `${30}px`
          this.addressesBodyHeight = height
          this.isFirstHeight = true
        }, 0)
      }
    }
  },
  watch: {
    inputValue () {
      this.calcContactListPosition()
    },
    values () {
      this.setBodyAddressesHeight()
      this.addressees = [...this.values]
    }
  },
  beforeMount () {
    this.setBodyAddressesHeight()
    this.addressees = [...this.values]
  },
  mounted () {
    this.getInputRef()
    this.addressesBodyHeight = get(this.$refs, 'bbeAddressesBody.offsetHeight', 0)
    this.toggleAccordionAddresses()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

$transition: 0.3s ease-in-out;

.bbe-address-form {
  display: grid;
  grid-template-columns: 59px 1fr auto;
  align-items: center;
  padding: 8px 0 0 0;
  border-bottom: 1px solid $color-gallery;
  overflow: hidden;
  transition: $transition;
  position: relative;

  &_close {
    height: 37px;
  }

  &-content {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 1;
    height: 100%;

    &__wrapper {
      position: relative;
      bottom: 0;

      &_bcc {
        z-index: -1;
      }
    }

    &-address {
      display: inline-grid;
      width: auto;
      grid-template-columns: auto 14px;
      grid-gap: 4px;
      align-items: center;
      justify-content: center;
      padding: 4px 8px;
      background-color: $color-link-water;
      color: $color-accent;
      font-weight: 500;
      font-size: 12px;
      line-height: 1;
      border-radius: 122px;
      margin-right: 8px;
      margin-bottom: 8px;
      white-space: nowrap;
      cursor: pointer;
      user-select: none;

      &__remove {
        padding: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        line-height: 1;
        opacity: 0.4;
        cursor: pointer;

        &:hover {
          color: $color-accent-hover;
          opacity: 0.8;
        }

        &:before {
          margin: 0;
        }
      }
    }
  }

  &__placeholder {
    position: sticky;
    top: 0;
    display: flex;
    align-self: flex-start;
    align-items: center;
    justify-content: flex-start;
    color: $color-silver-chalice;
    font-weight: 500;
    font-size: 13px;
    width: 59px;
    height: 30px;
    min-width: 59px;
    user-select: none;
    padding-bottom: 8px;
  }

  &__input {
    width: 100%;
    height: 22px;
    margin-bottom: 8px;
    font-size: 12px;
  }

  &__error {
    top: 0;
    right: 0;
  }

  &-controls {
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: flex-start;
    height: 26px;
    user-select: none;
  }

  &-buttons {
    display: flex;
    align-items: center;
    align-self: flex-start;

    &__copy {
      padding: 5px;
      font-size: 13px;
      color: $color-silver-chalice;
      cursor: pointer;
      transition: $transition;

      &:hover {
        text-decoration: underline;
        color: $color-dusty-gray;
      }

      &:last-child {
        margin-right: 10px;
      }
    }
  }

  &-toggle {
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: $color-accent;
    cursor: pointer;
    transition: $transition;
    z-index: 1;

    &_active &__icon {
      &:before {
        transform: rotate(0deg);
      }
    }

    &:hover {
      color: $color-accent-hover;
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 22px;
      font-size: 8px;
      border-radius: 122px;
      background-color: $color-link-water;
      margin-left: 4px;

      &:before {
        transition: $transition;
        transform: rotate(180deg);
        width: 14px;
        margin: 0;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/NewMail/NewMailFullSize/NewMailAddressInput.vue